import React, { useState } from 'react';
import { Card, Button, Badge, Modal, Form } from 'react-bootstrap';
import api from '../../api/axios';
import TicketFinalPrint from './TicketFinalPrint';
import { FiPrinter, FiTrash2, FiDollarSign } from 'react-icons/fi';

const MesaCardCobro = ({ mesa, onRefresh }) => {
  const { id, name, status, comensales_total, opened_at } = mesa;
  const [ticketFinal, setTicketFinal] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [ticketEmitido, setTicketEmitido] = useState(false);
  const [descuentoMonto, setDescuentoMonto] = useState(0);
  const [descuentoPorcentaje, setDescuentoPorcentaje] = useState(0);
  const [metodoPago, setMetodoPago] = useState('');


  const business = JSON.parse(localStorage.getItem('business'));

  const statusColors = {
    libre: 'success',
    ocupada: 'danger',
    en_espera: 'warning',
    abonada: 'secondary',
    para_cobrar: 'info',
  };

  const handleEmitirTicket = async () => {
    try {
      const res = await api.get('/pedidos/final-por-mesa', {
        params: { business_id: business.id }
      });

      const pedidosMesa = res.data[mesa.id];
      if (!pedidosMesa) {
        alert('No hay pedidos pendientes para emitir ticket.');
        return;
      }

      const items = [];
      let mozo = '';
      for (const pedido of Object.values(pedidosMesa)) {
        mozo = pedido.mozo || mozo;
        items.push(...pedido.items);
      }

      setTicketFinal({
        mesa,
        pedidos: Object.values(pedidosMesa)
      });
      setTicketEmitido(true);
      setShowModal(true);
    } catch (err) {
      console.error('Error al obtener pedidos para emitir ticket:', err);
      alert('Error al preparar el ticket');
    }
  };

  const calcularTotal = () => {
    if (!ticketFinal?.pedidos) return 0;

    return ticketFinal.pedidos.flatMap(p => p.items).reduce((sum, item) => {
      const precioUnitario = item.precio_unitario ?? item.price ?? 0;
      return sum + item.cantidad * precioUnitario;
    }, 0);
  };

  const handleMarcarComoAbonada = async () => {
    if (!window.confirm(`¿Marcar la mesa ${name} como abonada y liberar?`)) return;

    const totalSinDescuento = calcularTotal();
    const descuentoTotal =
      descuentoMonto + (descuentoPorcentaje > 0 ? totalSinDescuento * (descuentoPorcentaje / 100) : 0);
    const totalFinal = totalSinDescuento - descuentoTotal;
if (!metodoPago) {
  alert('Seleccioná un método de pago antes de finalizar.');
  return;
}

    try {
/*       const res = await api.patch(`/mesas/${id}/finalizar-cobro`, {
        descuento_monto: descuentoMonto,
        descuento_porcentaje: descuentoPorcentaje,
        total_final: totalFinal
      }); */
const res = await api.patch(`/mesas/${id}/finalizar-cobro`, {
  descuento_monto: descuentoMonto,
  descuento_porcentaje: descuentoPorcentaje,
  metodo_pago: metodoPago
});

      console.log('Resumen de cobro:', res.data);
      onRefresh();
      setTicketEmitido(false);
      setTicketFinal(null);
    } catch (err) {
      console.error('Error al finalizar el cobro:', err);
      alert('No se pudo completar el cobro');
    }
  };

  const handleLiberarMesa = async () => {
    if (!window.confirm(`¿Liberar la mesa ${name}?`)) return;
    try {
      await api.put(`/mesas/${id}`, {
        status: 'libre',
        mozo_id: null,
        closed_at: new Date().toISOString(),
      });
      onRefresh();
    } catch (err) {
      console.error('Error al liberar mesa:', err);
      alert('No se pudo liberar la mesa');
    }
  };

  const horaApertura = opened_at
    ? new Date(new Date(opened_at).getTime() - new Date(opened_at).getTimezoneOffset() * 60000)
        .toLocaleTimeString('es-AR', {
          hour: '2-digit',
          minute: '2-digit',
        })
    : '-';

  return (
    <>
      <Card className="mesa-card shadow-sm mb-3">
        <Card.Body>
          <Card.Title>
            Mesa {name}{' '}
            <Badge bg={statusColors[status.toLowerCase()] || 'secondary'} className="ms-2 text-capitalize">
              {status}
            </Badge>
          </Card.Title>
          <Card.Text>
            <strong>Comensales:</strong> {comensales_total || '-'}<br />
            <strong>Desde:</strong> {horaApertura}
          </Card.Text>

          <Form.Group className="mt-2">
            <Form.Label>Descuento ($)</Form.Label>
            <Form.Control
              type="number"
              min={0}
              value={descuentoMonto}
              onChange={(e) => setDescuentoMonto(Number(e.target.value))}
            />
          </Form.Group>

          <Form.Group className="mt-2">
            <Form.Label>Descuento (%)</Form.Label>
            <Form.Control
              type="number"
              min={0}
              max={100}
              value={descuentoPorcentaje}
              onChange={(e) => setDescuentoPorcentaje(Number(e.target.value))}
            />
          </Form.Group>
          <Form.Group className="mt-2">
  <Form.Label>Método de pago</Form.Label>
  <Form.Select
    value={metodoPago}
    onChange={(e) => setMetodoPago(e.target.value)}
  >
    <option value="">Seleccionar...</option>
    <option value="efectivo">💵 Efectivo</option>
    <option value="tarjeta">💳 Tarjeta</option>
    <option value="transferencia">🔁 Transferencia</option>
  </Form.Select>
</Form.Group>


          <div className="d-flex flex-wrap gap-2 mt-3">
            <Button variant="outline-success" size="sm" onClick={handleEmitirTicket}>
              <FiPrinter className="me-1" /> Emitir ticket
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={handleLiberarMesa}>
              <FiTrash2 className="me-1" /> Liberar mesa
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={handleMarcarComoAbonada}
              disabled={!ticketEmitido}
            >
              <FiDollarSign className="me-1" /> Marcar como abonada
            </Button>
          </div>
        </Card.Body>
      </Card>

      {ticketFinal && (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Body>
            <TicketFinalPrint
              mesa={ticketFinal.mesa}
              pedidos={ticketFinal.pedidos}
              descuento_monto={descuentoMonto}
              descuento_porcentaje={descuentoPorcentaje}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default MesaCardCobro;
